import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import * as MCFontConstants from 'src/styles/fonts/MCFontConstants';

// Create Material-UI theme instance for breakpoints
const theme = createTheme();



// Get color based on variant
const getVariantColor = (variant) => {
    switch (variant) {
        case 'bomChange':
            return MCFontConstants.PINK_HIGHLIGHT_COLOR;
        case 'reservationRequired':
            return MCFontConstants.RESERVATION_COLOR;
        case 'error':
            return MCFontConstants.RED_FONT_COLOR;
        case 'disabled':
            return MCFontConstants.DISABLED_FONT_COLOR;
        case 'secondary':
            return MCFontConstants.TITLE_FONT_COLOR;
        default:
            return MCFontConstants.PRIMARY_FONT_COLOR;
    }
};

// Get display style based on variant
const getDisplayVariant = (variant) => {
    switch (variant) {
        case 'flex':
            return 'flex';
        case 'flexColumn':
            return 'flex';
        case 'block':
            return 'block';
        case 'inline':
            return 'inline';
        case 'none':
            return 'none';
        default:
            return 'flex';
    }
};

// Get padding based on variant
const getPaddingVariant = (variant) => {
    switch (variant) {
        case 'iconSpacing':
            return '0px 5px 0px 0px';
        case 'none':
            return '0px';
        case 'small':
            return '4px';
        case 'medium':
            return '8px';
        case 'large':
            return '16px';
        default:
            return '0px';
    }
};

// Get font size based on variant using MCFontConstants
const getFontSizeVariant = (variant) => {
    switch (variant) {
        case 'xxSmall':
            return MCFontConstants.XX_SMALL_TEXT_PX;
        case 'xSmall':
            return MCFontConstants.SEMANTIC_TEXT_XSMALL_PX;
        case 'small':
            return MCFontConstants.X_SMALL_TEXT_PX;
        case 'body':
            return MCFontConstants.SEMANTIC_TEXT_SMALL_PX;
        case 'medium':
            return MCFontConstants.SMALL_TEXT_PX;
        case 'semantic':
            return MCFontConstants.SEMANTIC_TEXT_PX;
        case 'large':
            return MCFontConstants.BASE_TEXT_PX;
        case 'xlarge':
            return MCFontConstants.LARGE_TEXT_PX;
        case 'xxlarge':
            return MCFontConstants.X_LARGE_TEXT_PX;
        default:
            return MCFontConstants.SEMANTIC_TEXT_XSMALL_PX;
    }
};

// Get width based on variant
const getWidthVariant = (variant) => {
    switch (variant) {
        case 'full':
            return '100%';
        case 'auto':
            return 'auto';
        case 'medium':
            return '83px';
        case 'small':
            return '50px';
        case 'large':
            return '150px';
        default:
            return 'auto';
    }
};

// Get height based on variant
const getHeightVariant = (variant) => {
    switch (variant) {
        case 'button':
            return '35px';
        case 'small':
            return '19px';
        case 'medium':
            return '40px';
        case 'large':
            return '60px';
        case 'auto':
            return 'auto';
        default:
            return 'auto';
    }
};



export const CartActionItems = styled.div`
    font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : MCFontConstants.FONT_FAMILY_BOLD)};
    color: ${({ color }) => (color ? color : MCFontConstants.DARK_NAVY_FONT_COLOR)};
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    display: ${({ display }) => (display ? display : 'flex')};
    flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : 'row')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : MCFontConstants.SEMANTIC_TEXT_SMALL_PX)};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
    justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'center')};
    width: ${({ width, widthVariant }) => 
        width ? width : 
        widthVariant ? getWidthVariant(widthVariant) : 'auto'};
    height: ${({ height, heightVariant }) => 
        height ? height : 
        heightVariant ? getHeightVariant(heightVariant) : 'auto'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};
    padding: ${({ padding }) => (padding ? padding : '0')};
    
    ${theme.breakpoints.down('xs')} {
        font-family: ${MCFontConstants.FONT_FAMILY_DEMI};
        color: ${MCFontConstants.DARK_GRAY_FONT_COLOR};
        font-size: ${MCFontConstants.X_SMALL_TEXT_PX};
    }
`;



export const Text = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : MCFontConstants.FONT_FAMILY_DEMI};
    font-size: ${({ fontSize, fontSizeVariant }) => 
        fontSize ? fontSize : 
        fontSizeVariant ? getFontSizeVariant(fontSizeVariant) : MCFontConstants.SEMANTIC_TEXT_XSMALL_PX};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '600')};
    color: ${({ color, variant }) => 
        color ? color : variant ? getVariantColor(variant) : MCFontConstants.PRIMARY_FONT_COLOR};
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
    width: ${({ width, widthVariant }) => 
        width ? width : 
        widthVariant ? getWidthVariant(widthVariant) : 'auto'};
    height: ${({ height, heightVariant }) => 
        height ? height : 
        heightVariant ? getHeightVariant(heightVariant) : 'auto'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};
    padding: ${({ padding }) => (padding ? padding : '0')};
    display: ${({ display }) => (display ? display : MCFontConstants.DISPLAY)};
    cursor: ${({ cursor }) => (cursor ? cursor : 'default')};
    
    ${theme.breakpoints.down('xs')} {
        font-size: ${({ fontSize, fontSizeVariant }) => 
            fontSize ? fontSize : 
            fontSizeVariant ? getFontSizeVariant(fontSizeVariant) : MCFontConstants.X_SMALL_TEXT_PX};
    }
`;



export const AddIcon = styled.div`
    display: ${({ isReviewSubmitScreen, display, displayVariant }) =>
        isReviewSubmitScreen ? null : 
        display ? display : 
        displayVariant ? getDisplayVariant(displayVariant) : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding, paddingVariant }) =>
        isReviewSubmitScreen ? null : 
        padding ? padding : 
        paddingVariant ? getPaddingVariant(paddingVariant) : '0px 5px 2px'};
    cursor: ${({ cursor }) => (cursor ? cursor : MCFontConstants.CURSOR)};
`;


// Add Product Title Section
export const AddProductTitleSection = styled(Grid)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    ${theme.breakpoints.down('sm')} {
        justify-content: center;
    }
`;

export const AddProductTitle = styled.div`
    color: ${({ color }) => (color ? color : MCFontConstants.PRIMARY_FONT_COLOR)};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : MCFontConstants.BASE_TEXT_PX)};
    font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : MCFontConstants.FONT_FAMILY_DEMI)};
    text-align: center;
    white-space:nowrap;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};
    height: ${({ height }) => (height ? height : 'auto')};
`;


// Product Search Section
export const ProductSearchSection = styled(Grid)`
    display: flex;
    align-items: center;
    width: 100%;
    flex: 1;
`;

export const SearchWrapper = styled.div`
    width: 100%;
    
    /* Inherit only specific styles, not layout properties */
    .product-search-component {
        color: inherit;
        font-size: inherit;
        font-family: inherit;
        font-weight: inherit;
        
        /* Override width/height/margin/padding */
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        
        /* Ensure all child elements use full width */
        & > * {
            width: 100% !important;
            max-width: 100% !important;
        }
        
        /* Override any fixed width constraints from ProductSearch component */
        div[class*="QuickOrder"] {
            width: 100% !important;
            max-width: 100% !important;
        }
    }
`;






// Individual Product Method Item
export const ProductMethodItem = styled.div`
    color: ${MCFontConstants.TITLE_FONT_COLOR};
    font-size: ${MCFontConstants.SMALL_TEXT_PX};
    font-family: ${MCFontConstants.FONT_FAMILY_DEMI};
    cursor: pointer;
    white-space: nowrap;
    
    ${theme.breakpoints.down('sm')} {
        font-size: ${MCFontConstants.SMALL_TEXT_PX};
    }
`;

// Container Components - replacing Material-UI makeStyles
export const MobileOuterContainer = styled.div`
    ${theme.breakpoints.down('xs')} {
        background: ${({ isFromEquityTemplate }) =>
            isFromEquityTemplate ? 'none' : `${MCFontConstants.WHITE_FONT_COLOR} 0% 0% no-repeat padding-box`};
        box-shadow: ${({ isTemplate }) =>
            isTemplate ? 'none' : '0px 0px 6px #00000029'};
        margin: 10px 0;
        padding: 0;
    }
`;

export const MainContainer = styled.div`
    width: 100%;
    margin: 0 0 10px 0;
    padding: ${({ isTemplate }) => (isTemplate ? '5px' : '5px 10px')};
    background-color: ${MCFontConstants.WHITE_FONT_COLOR};
    background: ${({ isFromEquityTemplate }) =>
        isFromEquityTemplate ? 'none' : `${MCFontConstants.WHITE_FONT_COLOR} 0% 0% no-repeat padding-box`};
    box-shadow: ${({ isTemplate }) =>
        isTemplate ? 'none' : '0px 0px 6px #00000029'};
    border-radius: 6px;
    
    ${theme.breakpoints.down(750)} {
        padding: ${({ isTemplate }) => (isTemplate ? '5px' : '5px')};
    }
    
    ${theme.breakpoints.down('xs')} {
        margin: 0;
        background: none;
        box-shadow: none;
        border-radius: 0;
    }
`;

export const CartContainer = styled.div`
    width: 100%;
    margin: 0 0 5px 0;
    padding: 5px 10px;
    justify-content: space-between;
    
    ${theme.breakpoints.down(700)} {
        padding: 5px;
    }
    
    ${theme.breakpoints.down('xs')} {
        margin: 0;
        padding: 5px 10px;
    }
`;

export const GridItemContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 0 0 10%;
    min-height: 48px;
    padding: 0;

    /* When BOTH language is changed (Japanese) AND isTemplate, use consistent 10% flex */
    ${({ isLanguageChanged, isTemplate }) => (isLanguageChanged && isTemplate) && `
        ${theme.breakpoints.between(600, 'lg')} {
            flex: 0 0 10%;
        }
    `}

    /* When language is NOT changed OR NOT template, use different flex values per breakpoint */
    ${({ isLanguageChanged, isTemplate }) => !(isLanguageChanged && isTemplate) && `
        ${theme.breakpoints.between(1101, 'lg')} {
             flex:  ${isLanguageChanged ? '1 0 11%' : '0 0 10%'};
        }

        ${theme.breakpoints.between(850, 1100)} {
            flex:  ${isLanguageChanged ? '1 0 14%' : '0 0 13%'};
        }

        ${theme.breakpoints.between(750, 850)} {
            flex: ${isLanguageChanged ? '1 0 15%' : '0 0 15%'};
        }
        
        ${theme.breakpoints.between(700, 750)} {
            flex: 0 1 15%;
        }

        ${theme.breakpoints.between(600, 700)} {
            flex: 0 1 19%;
        }
    `}
    
    ${theme.breakpoints.down('xs')} {
        flex: 1 1 50%;
        min-height: 35px;
    }
`;

export const SearchGridItemContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 0 0 40%;
    min-height: 48px;
    padding: 0 3% 0 0;

      ${theme.breakpoints.between(1100, 'lg')} {
      padding: 0 3% 0 0;
        flex: 0 0 40%;
    }
    
    ${theme.breakpoints.between(750, 1100)} {
    padding: 0 ;
        flex: 0 0 35%;
    }

      ${theme.breakpoints.between(600, 750)} {
      padding: 0;
        flex: 1 1 29%;
    }
    
    ${theme.breakpoints.down('xs')} {
    padding: 0;
        flex: 1 1 100%;
    }
`;

export const ProductMethodsContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1 1 40%;
    min-height: 48px;
    padding: 0;
    justify-content: ${({ visibleCount }) => visibleCount < 3 ? 'flex-start' : 'space-between'};
    gap: ${({ visibleCount }) => visibleCount < 3 ? '40px' : '10px'};

    ${theme.breakpoints.between(750, 'md')} {
        gap: ${({ visibleCount }) => visibleCount < 3 ? '40px' : '5px'};
        flex: 1 0 45%;
    }

      ${theme.breakpoints.between(600, 750)} {
        flex: 1 1 30%;
    }
    
    ${theme.breakpoints.down('xs')} {
        flex: 1 1 100%;
        justify-content: ${({ visibleCount }) => visibleCount < 3 ? 'flex-start' : 'space-between'};
         min-height: 35px;
    }
`;

export const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 15px;


     ${theme.breakpoints.between(1090,'md')} {
        gap: ${({ isTemplate, isFromEquityTemplate }) => 
            isTemplate || isFromEquityTemplate ? '10px' : '15px'};
    }
     ${theme.breakpoints.between(960,1090)} {
        gap: 8px;
    }    
    ${theme.breakpoints.between(750,960)} {
        gap: 15px;
    } 
    ${theme.breakpoints.between(600,750)} {
        gap: 5px;
    }

    
    ${theme.breakpoints.down('xs')} {
        padding: ${({ isTemplate, isFromEquityTemplate }) => 
            isFromEquityTemplate && isTemplate? '0 2%' : 
            isTemplate ? '0' : '0 10px'};
        gap: 5px;
        
    }
`;

export const FlexContainerCart = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    ${theme.breakpoints.down('xs')} {
        padding: 0 10px;
        gap: 5px;
        min-height: 35px;
    }
`;

export const CartActionItemsContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1 1 100%;
    min-height: 48px;
    padding: 0;
    justify-content: flex-start;
    gap: 10px;
    
    ${theme.breakpoints.down('sm')} {
        justify-content: flex-start;
        padding: 0 5px;
        gap: 5px;
    }
`;

export const CartActionItemsContainerSpaceBetween = styled.div`
    display: flex;
    align-items: center;
    flex: 1 1 100%;
    min-height: 48px;
    padding: 0;
    justify-content: flex-start;
    gap: 10px;
    
    ${theme.breakpoints.down('sm')} {
        justify-content: space-between;
        padding: 0 5px;
        gap: 5px;
        min-height: 35px;
    }

    ${theme.breakpoints.down('xs')} {
        padding: 0px;
    }
`;

export const TopCartActionsContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-height: 48px;
    padding: 0;
    justify-content: flex-end;
    gap: 20px;
    
    ${theme.breakpoints.down('sm')} {
        flex: 1 1 66.67%;
        gap: 10px;
    }
    
    ${theme.breakpoints.down('xs')} {
        flex: 1 1 40%;
        justify-content: flex-end;
      min-height: 35px;
    }
`;


